<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("city", 1) }}
      </div>
      <router-link class="btn-blue" to="cities"
        >{{ $tc("city", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Cities"
          :key="index"
          v-if="item.fieldname !== 'city_id'"
          class="col-lg-5 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.type !== 'radio' && item.type !== 'dropdown'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.type === 'radio'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <label class="ios-switch">
                <input
                  type="checkbox"
                  class="ios-checkbox"
                  v-model="item.fieldvalue"
                />
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span></span>
            </p>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'country_id'">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search country"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchCountry()"
                        v-on:keydown="onSearchCountry()"
                        v-on:search="onSearchCountry()"
                        v-model="searchCountry"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in countryList"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.country_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgcountry
                }}</span>
              </p>
            </div>

            <div v-if="item.fieldname === 'state_id'">
              <div class="d-flex align-items-center">
                <div class="d-flex mt-2 pr-2"></div>

                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <div class="px-2 pb-2">
                      <input
                        required
                        autofocus
                        type="search"
                        placeholder="Search state"
                        class="form-control form-control-sm"
                        v-on:keyup="onSearchState()"
                        v-on:keydown="onSearchState()"
                        v-model="searchState"
                      />
                    </div>
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in stateList"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.state_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgstate
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="cities">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Cities from "@/helper/formJSONMaster/Cities";

export default {
  data() {
    return {
      btenable: false,
      msgcountry: "Please Select Country.",
      msgstate: "Please Select State.",
      Cities: Cities.ms_cities,
      Methods: Cities.Methods,
      submitted: false,
      countryList: [],
      stateList: [],
      countryListCopy: [],
      searchCountry: "",
      stateListCopy: [],
      searchState: "",
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onResetForm: function () {
      this.Cities.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "dropdown") {
          x.fieldvalue = "";
          x.dropdownSelected = "select";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            // console.log("obj :", obj);
            this.Cities.map((x, index) => {
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else if (x.type === "dropdown") {
                x.fieldvalue = obj[x.fieldname];
                // x.dropdownSelected = obj[x.fieldname];
                // if (x.fieldname === "country_id") {
                //   this.getCountryList(obj[x.fieldname], index);
                // }
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            this.getCountryList(obj["country_id"]);
            this.getStateList(obj["state_id"], obj["country_id"]);
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onSearchState: function () {
      if (this.searchState && this.searchState.length > 0) {
        this.stateList = this.stateListCopy.filter((x) => {
          if (
            x.state_name.toLowerCase().includes(this.searchState.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.stateList = this.stateListCopy;
      }
    },
    getStateList: function (uniqueId, countryId) {
      this.stateList = [];
      if (countryId) {
        let body = this.getRequestBody("GET", undefined, {
          GET: "/admin/tablelist/",
          tableName: "ms_states",
          params: { id: "country_id-" + countryId },
        });
        MasterService.GlobalRequest(body)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.stateList = data.Records;
              this.stateListCopy = data.Records;
              if (uniqueId) {
                this.setNestedDropdownFields(
                  "state_id",
                  uniqueId,
                  data.Records
                );
              } else {
                // this.setStateHandler(countryId);
                this.setDropdownHandler(null, "state", data.Records, ["city"]);
              }
            } else {
              // Show Errors
              console.log("show error :", data.message);
              this.setStateHandler(null);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      }
    },
    onSearchCountry: function () {
      if (this.searchCountry && this.searchCountry.length > 0) {
        this.countryList = this.countryListCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              .includes(this.searchCountry.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    getCountryList: function (uniqueId) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
            this.setNestedDropdownFields("country_id", uniqueId, data.Records);
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    setNestedDropdownFields: function (name, id, array) {
      let filterObj = id ? array.filter((x) => x[name] === id) : null;
      this.Cities.map((x) => {
        if (name == "country_id" && name === x.fieldname) {
          x.dropdownSelected = filterObj
            ? filterObj[0].country_name
            : "Select Country";
        } else if (name == "state_id" && name === x.fieldname) {
          x.dropdownSelected = filterObj
            ? filterObj[0].state_name
            : "Select State";
        } else if (name == "city_id" && name === x.fieldname) {
          x.dropdownSelected = filterObj
            ? filterObj[0].city_name
            : "Select City";
        }
      });
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      if (type === "country") {
        this.Cities[mainIndex].fieldvalue = item.country_id;
        this.Cities[mainIndex].dropdownSelected = item.country_name;
        this.getStateList(item.country_id, null);
      } else if (type === "state") {
        this.Cities[mainIndex].dropdownSelected = item.state_name;
        this.Cities[mainIndex].fieldvalue = item.state_id;
      }
    },
    onUpdateHandler: function () {
      // let body = this.getRequestBody("PUT", this.Cities, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/cities"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          // console.log("valid :", valid);
          if (this.Cities[4].fieldvalue == "") {
            return;
          } else if (this.Cities[5].fieldvalue == "") {
            return;
          } else {
            this.btenable = true;
            let body = this.getRequestBody("PUT", this.Cities, {
              ...this.Methods,
              params: { id: this.$route.query.id },
            });

            MasterService.GlobalRequest(body)
              .then((response) => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  this.$router.push({
                    path: "/master/cities",
                  });
                } else {
                  console.log("show error :", data.message);
                  this.$toasted.show(Error(data.message));
                }
              })
              .catch((error) => {
                console.log("show error2 :", error);
              });
          }
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CityComponents/editCity.vue